<template>
    <div class="table_container">
        <common-layout>
            <div slot="header">
                <h3>军民融合管理</h3>
            </div>
            <div slot="container">
                <!-- <div class="handle-box">
                    <el-input style="width:30%;margin:0 10px" placeholder="视频关键词" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <el-select>
                        <el-option value label="全部"></el-option>
                        <el-option value="1" label="学习课程"></el-option>
                        <el-option value="2" label="点播课程"></el-option>
                    </el-select>
                </div> -->
                <div id="table">
                    <el-table ref="multipleTable" :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }" :data="tableData" style="width: 100%" type="index" >
                        <el-table-column type="index" width="100" label="序号" align="center"></el-table-column>
                        <el-table-column prop="title" label="名称" align="center"></el-table-column>
                        <el-table-column prop="createTime" label="添加日期" align="center"></el-table-column>
                        <el-table-column prop="creatorName" label="操作员" align="center"></el-table-column>
                        <el-table-column label="操作" align="center" width="120">
                            <template slot-scope="scope">
                                <el-button-group>
                                    <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                                </el-button-group>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pagination">
                    <div class="grid-content bg-purple-light">
                        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next,jumper"
                            :total="total" :current-page.sync="current_page" :page-size="per_page"></el-pagination>
                    </div>
                </div>
            </div>
        </common-layout>
        <el-dialog
            title="修改军民融合管理"
            :visible.sync="dialogFormVisible"
            :close-on-click-modal="false"
            width="50%"
            >
            <el-form :model="form" ref="form">
                <el-form-item
                    label="标题"
                    :label-width="formLabelWidth"
                >
                    <el-input
                        v-model="form.title"
                        autocomplete="off"
                        placeholder="请输入标题"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    label="累计服务数据(数据顺序：征集技术需求|征集技术产品目录|推介技术项目|举办技术对接活动)"
                    :label-width="formLabelWidth"
                >
                    <el-input
                    type="textarea"
                    v-model="form.cumulativeServiceData"
                    :rows="2"
                    placeholder="请输入累计服务数据(数据顺序：征集技术需求|征集技术产品目录|推介技术项目|举办技术对接活动)"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="年份(用竖线相隔，如2024|2025)"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.years"
                    :rows="2"
                    placeholder="请输入年份(用竖线相隔，如2024|2025)"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="征集技术需求(用符号相隔)"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.collectTechnicalRequirements"
                    :rows="2"
                    placeholder="请输入征集技术需求(用符号相隔)"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="征集技术产品目录"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.callForTechnicalProductCatalogues"
                    :rows="2"
                    placeholder="请输入征集技术产品目录"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="开展技术对接活动"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.carryOutTechnicalDockingActivities"
                    :rows="2"
                    placeholder="请输入开展技术对接活动"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="达成意向合作"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.reachedIntentionToCooperate"
                    :rows="2"
                    placeholder="请输入达成意向合作"
                   >
                    </el-input>
                </el-form-item>
                <el-form-item
                    label="培训服务人次"
                    :label-width="formLabelWidth"
                >
                <el-input
                    type="textarea"
                    v-model="form.trainingServicePersonTimes"
                    :rows="2"
                    placeholder="请输入培训服务人次"
                   >
                    </el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">修 改</el-button>
                <el-button type="warning" @click="dialogFormVisible=false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import CommonLayout from "../../../components/common-layout.vue";
export default {
    components: {
        CommonLayout,
    },
    data() {
        return {
            tableData: [], //列表数据
            total: 10, //总页数
            current_page: 1, //当前页
            per_page: 20, //每页条数
            dialogFormVisible: false,
            form: {},
            formLabelWidth: "220px"
        };
    },
    created() {
        this.getData();
    },
    computed: {
    },
    methods: {
        onSubmit() {
            let params = {
                ...this.form,
                isShow: 1,
                id: this.form.id
            }
            this.http.put('apij2/admin-api/voucher/large-screen-civil-military-integration-management/update', params).then((response) => {
                if (response.code == 0) {
                    this.$message.success('修改成功');
                    this.getData()
                    this.dialogFormVisible = false;
                }
            });
        },
        handleEdit(item) {
            this.form = {}

            this.$nextTick(() => {
                this.form = {...item};
                this.dialogFormVisible = true;
            });
        },
        //获取列表数据
        getData() {
            let params = {
                page: this.current_page,
                pageSize: this.per_page,
            }
            this.http.post('apij2/admin-api/voucher/large-screen-civil-military-integration-management/page', params).then((response) => {
                this.tableData = response.data.data;
                this.total = response.data.total; //总页数
                this.per_page = response.data.per_page;
                this.current_page = response.data.current_page;
            });
        },
        //选择页码
        handleCurrentChange(e) {
            this.current_page = e;
            this.getData();
        },
    },
};
</script>
<style lang="scss" scoped>
* {
    word-break: normal;
}

.table_container {
    height: 100%;
    text-align: left;

    .handle-box {
        .handle-input {
            /deep/.el-input__suffix {
                margin-right: 10px;
            }
        }
    }

    #table {
        margin-top: 20px;
        border: 1px solid #eef1f6;

        /deep/ th {
            // background-color: #eef1f6 !important;
            // color: #000;
        }

        /deep/ td {}

        /deep/ .cell {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            img {
                max-width: 100px;
                max-height: 100%;
                width: auto;
                height: auto;
            }
        }

        p {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .pagination {
        margin-top: 10px;
    }

    /deep/ .el-dialog__header {
        text-align: center !important;
    }
}

.mess {
    color: red;
    margin-left: 20px;
}
/deep/ .el-dialogFormVisible__header{
		border-bottom: 1px solid #ccc;
		font-size: 20px;
		font-weight: 500;
		padding-bottom: 20px;
		margin-bottom: 10px;
	}
    /deep/ .el-dialogFormVisible__body{
        padding: 20px;
    }
</style>
